import { render } from "./ProjectPublication.vue?vue&type=template&id=77bd201b"
import script from "./ProjectPublication.vue?vue&type=script&lang=js"
export * from "./ProjectPublication.vue?vue&type=script&lang=js"

import "./ProjectPublication.vue?vue&type=style&index=0&id=77bd201b&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__